import script from "./DiaryEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./DiaryEntry.vue?vue&type=script&setup=true&lang=js"

import "./DiaryEntry.vue?vue&type=style&index=0&id=06ead386&lang=css"

const __exports__ = script;

export default __exports__